import assert from 'assert'
import classNames from 'classnames'
import React, { MouseEventHandler, ReactNode } from 'react'
import { useTranslate } from '../src/hooks/useTranslate'
import { ImageFragment, LinkType } from '../src/model/fragments'
import { FileExtension } from '../src/utils/mimeTypeToFileExtension'
import { Picture, PictureEncode } from './Picture'
import { Card, CardView } from './Card'
import { FlexiLink } from './FlexiLink'

export interface CardDownloadProps {
	title: string | ReactNode
	suffix?: string | ReactNode
	href: string
	isDownloading?: boolean
	onClick?: MouseEventHandler<HTMLAnchorElement>
	extension: FileExtension
	imageIcon?: ImageFragment
	svgIcon?: ReactNode
	className?: string
}

export const CardDownload: React.FC<CardDownloadProps> = ({
	className,
	title,
	href,
	imageIcon,
	svgIcon,
	isDownloading,
	onClick,
	suffix
}) => {
	const translate = useTranslate()
	assert((href || onClick) && !(href && onClick));

	return (
		<Card clickable view={CardView.small} className={classNames('cardDownload', isDownloading && 'cardDownload--downloading', className)}>
			<FlexiLink type={LinkType.external} externalLink={href} aria-label={translate('download')}>
				<a className='cardDownload-content' onClick={isDownloading ? () => {} : onClick}>
					<div className='cardDownload-image'>
						{ svgIcon }
						{ !svgIcon && imageIcon && <Picture
							alt={translate('download-thumbnail-alternative')}
							mode={'contain'}
							image={imageIcon}
							encode={imageIcon ? (imageIcon.intrinsicEncode ?? PictureEncode.png) : PictureEncode.svg}
							width={imageIcon ? 30 : 30}
							height={imageIcon ? 30 : 30}
						/>}
					</div>
					<div className='cardDownload-text'>
						{ title }
					</div>
					{
						suffix && <div className='cardDownload-suffix' data-download-text={ translate('card-download') }>
							{ suffix }
						</div>
					}
					
				</a>
			</FlexiLink>
		</Card>
	)
}
